import { Component, Input, NgModule, OnInit } from '@angular/core';
import { Advert } from '@model/entities/advert';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { EntityTypeIdentifier } from '@type/entity-type-identifier';
import { EntityCardComponent } from '@component/generic/cards/entity-card.component';
import { ScrollService } from '@service/scroll.service';
import { ViewsDisplayModule } from '@component/interaction-buttons/views-display/views-display.component';
import { EnumtranslatePipeModule } from '@pipe/enumtranslate.pipe';
import { MoneyInsertThousandSignsModule } from '@pipe/money-insert-thousand-signs';
import { SharedModule } from 'src/app/shared.module';
import { StateService } from '@service/state.service';

@Component({
  selector: 'advert-grid-item',
  templateUrl: './advert-grid-item.component.html',
  styleUrls: ['./advert-grid-item.component.scss'],
})
export class AdvertGridItemComponent extends EntityCardComponent implements OnInit {
  protected entityTypeIdentifier: EntityTypeIdentifier = 'advert';

  @Input()
  public entity: Advert = null;

  constructor(
    protected entityTypeConfigService: EntityTypeConfigService,
    protected ScrollService: ScrollService,
    public StateService: StateService,
  ) {
    super(entityTypeConfigService, ScrollService, StateService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}

@NgModule({
  declarations: [AdvertGridItemComponent],
  imports: [SharedModule, EnumtranslatePipeModule, MoneyInsertThousandSignsModule, ViewsDisplayModule],
  exports: [
    AdvertGridItemComponent,

    SharedModule,
    EnumtranslatePipeModule,
    MoneyInsertThousandSignsModule,
    ViewsDisplayModule,
  ],
})
export class AdvertGridItemModule {}
